<template>
  <div class="layoutCard">
    <v-lazy-image
      :ref="data._id"
      class="cover"
      :src="getCoverImage(data)"
      :src-placeholder="logoImg"
      @click.native="openGallery"
      @error.native="getImgPlaceholder"
      :alt="data.name"
      @load="getImgExif"
    />
    <div class="title">
      <span>
        {{data.name}}
      </span>
    </div>
  </div>
</template>

<script>
import EXIF from "exif-js";
import _ from "lodash";
import logoImg from "@/assets/logo_square.png";
import VLazyImage from "v-lazy-image";
import BuildingLayout from "@/service/BuildingLayout";
const BuildingLayoutService = new BuildingLayout();
export default {
  name: "LayoutCard",
  props: {
    data: Object
  },
  components: {
    VLazyImage
  },
  data() {
    return {
      logoImg
    };
  },
  methods: {
    openGallery(e) {
      BuildingLayoutService.getLayoutImages(this.data.name)
        .then(d => {
          this.$photoGallery.open(0, d, this.photoSwipeOption(e));
        })
        .catch(e => null);
    },
    photoSwipeOption(e) {
      return {
        closeOnScroll: true,
        shareEl: false,
        getThumbBoundsFn: function() {
          return { x: e.x, y: e.y, w: 0 };
        }
        // showAnimationDuration: 333
      };
    },
    getImgExif() {
      const img = this.$refs[this.data.id].$el;
      EXIF.getData(img, function() {
        var orientation = EXIF.getTag(this, "Orientation");
        console.log("or", orientation);
        if (orientation == 6) {
          img.classList.add("rotate90");
        } else if (orientation == 8) {
          img.classList.add("rotate270");
        }
      });
    },
    getImgPlaceholder(e) {
      // console.log("hi", e);
      e.target.src = logoImg;
      e.target.classList.add("v-lazy-image-loaded");
    },
    getCoverImage(d) {
      const buildingName = _.get(d, "name", "");
      if (buildingName) {
        return `https://s3-ap-southeast-1.amazonaws.com/top-agent-macau-building-layouts/${buildingName}/${buildingName}.jpg`;
      } else {
        return logoImg;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.rotate90 {
  transform: rotate(90deg);
}
.rotate270 {
  transform: rotate(270deg);
}
.layoutCard {
  width: 200px;
  height: 250px;
  // transition: all 50ms ease-out;
  cursor: pointer;
  &:hover {
    transform: translateY(-2px) scale(1.005) translateZ(0);
    // box-shadow: 0 24px 36px rgba(0, 0, 0, 0.11), 0 24px 46px rgba(0, 0, 0, 0.11);
  }
  user-select: none;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  position: relative;
  background-color: #f0eff4;
  border-radius: 10px;
  > img.cover {
    display: block;
    width: 200px;
    height: 200px;
    object-fit: fill;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  > .title {
    display: flex;
    align-items: center;
    flex: 1;
    padding: 0 16px;
  }
}
@media all and (max-width: 769px) {
  .layoutCard {
    width: 165px;
    height: 206.25px;
    > img.cover {
      width: 165px;
      height: 165px;
    }
  }
}
</style>
